export function addCurrent(type) {
    return {
        _type: 'ADD_CURRENT',
        type,
    }
}
